// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"Balance_balanceWrapper__YuzFY","title":"Balance_title__oemrt","balance":"Balance_balance__uuLBa"};